import { render, staticRenderFns } from "./DocumentTypeCard.vue?vue&type=template&id=3ff8a780&scoped=true&"
import script from "./DocumentTypeCard.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypeCard.vue?vue&type=style&index=0&id=3ff8a780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff8a780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ff8a780')) {
      api.createRecord('3ff8a780', component.options)
    } else {
      api.reload('3ff8a780', component.options)
    }
    module.hot.accept("./DocumentTypeCard.vue?vue&type=template&id=3ff8a780&scoped=true&", function () {
      api.rerender('3ff8a780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/modals/wizard/components/DocumentTypeCard.vue"
export default component.exports